import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { UserService } from './services/user.service';
import { AnalyticsConsentService } from './services/analytics-consent.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(private router: Router, private titleService: Title, private userService: UserService, private analyticsConsent: AnalyticsConsentService) { }
    //title = 'noteefy-webserver';

    ngOnInit() {
        this.analyticsConsent.init();

        if (environment.production) {
            this.setUpAnalytics();
        }
    }

    setUpAnalytics() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                console.log('ROUTER EVENT : ', event);
                
                if (event.url == "/user") {
                    this.titleService.setTitle("Noteefy - Mon compte");
                } else if (event.url == "/devices") {
                    this.titleService.setTitle("Noteefy - Numéros");
                } else if (event.url.startsWith("/login")) {
                    this.titleService.setTitle("Noteefy - Authentification");
                } else if (event.url.startsWith("/register")) {
                    this.titleService.setTitle("Noteefy - Inscription");
                } else {
                    this.titleService.setTitle("Noteefy");
                }
                
                /*if (this.userService.currentUserID) {
                    //console.log('ROUTER EVENT with user id : ' + this.userService.currentUserID);
                    gtag('config', environment.googleAnalyticsID, 
                        {
                            'page_path': event.urlAfterRedirects,
                            'user_id': this.userService.currentUserID
                        }
                    );
                } else {
                    //console.log('ROUTER EVENT without user id ');
                    gtag('config', environment.googleAnalyticsID, 
                        {
                            'page_path': event.urlAfterRedirects
                        }
                    );
                }*/
            }
        });
    }
}
